export default function onChangeNumber(e, onChange) {
  let value = e.target.value;

  const digitsOnly = value.replace(/\D+/g, "");

  if (digitsOnly === "") {
    onChange("");
    return;
  }

  onChange(digitsOnly);
}
